import { CoachingType, GoalStatus } from '../../coaching-base/general';
import { TranslationKeyMap } from '../coaching-insight.i18n';

const statusTranslationMap: { [key in GoalStatus]: string } = {
    [GoalStatus.DRAFT]: TranslationKeyMap._9476_DRAFT,
    [GoalStatus.PRE_APPROVAL]: TranslationKeyMap._9791_PENDING_APPROVAL,
    [GoalStatus.ACTIVE]: TranslationKeyMap._125_ACTIVE,
    [GoalStatus.UPDATING]: TranslationKeyMap._9791_PENDING_APPROVAL,
    [GoalStatus.PENDING_CLOSE]: TranslationKeyMap._7441_PENDING_CLOSE,
    [GoalStatus.CLOSED]: TranslationKeyMap._7440_CLOSED,
    [GoalStatus.DELETED]: TranslationKeyMap._9496_DELETED,
};

export function determineStatusLabel(
    statusId: GoalStatus,
    disputed: boolean,
    actual: number,
    percentToGoal: number,
    coachTypeId: CoachingType,
): string {
    let result = statusTranslationMap[statusId];
    if (disputed) {
        result = TranslationKeyMap._8703_DISPUTED;
    } else if (actual == null || percentToGoal == null) {
        result = TranslationKeyMap._852_NO_DATA;
    } else if (
        coachTypeId === CoachingType.UNCOACHED ||
        coachTypeId === CoachingType.MISSED
    ) {
        result = TranslationKeyMap._7343_NO_GOAL;
    } else if (
        statusId !== GoalStatus.PRE_APPROVAL &&
        statusId !== GoalStatus.UPDATING &&
        statusId !== GoalStatus.PENDING_CLOSE &&
        statusId !== GoalStatus.CLOSED
    ) {
        result = null;
    }
    return result;
}
